module.exports = __webpack_public_path__ + "img/1F633.8b8ff612.svg";